import { useState } from "react";
import { Loader2, QrCode, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { DepotPicker } from "@/components/DepotPicker";
import { useDepot } from "@/context/DepotContext";
import { useJoinLink } from "./joinLink";
import { QrCard, ShareRow, EmailInvite, ResetLink } from "./JoinLinkParts";

// Workers tab: the company/depot join link + QR code, with share, print, email and reset.
export const InviteCrewDialog = () => {
  const { isAdmin, depots, depot, nameOf } = useDepot();
  const [open, setOpen] = useState(false);
  const [depotId, setDepotId] = useState(depot || "");
  const { link, busy, reset } = useJoinLink(depotId, open);
  const onOpen = (o) => { if (o) setDepotId(depot || ""); setOpen(o); };
  const where = link ? (link.depot_name ? `${link.company_name} · ${link.depot_name}` : link.company_name) : "";

  return (
    <Dialog open={open} onOpenChange={onOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-full" data-testid="invite-crew-btn"><QrCode className="w-4 h-4 mr-2" />Invite link / QR</Button>
      </DialogTrigger>
      <DialogContent className="max-w-xl max-h-[92vh] overflow-y-auto" data-testid="invite-crew-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Invite new staff</DialogTitle>
          <DialogDescription>Send this link or QR code to new staff. They create their login, install the app and join your crew straight away.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 min-w-0">
          {isAdmin && depots.length > 0
            ? <DepotPicker always value={depotId} onChange={setDepotId} label="They join" noneLabel="Whole company (no home depot)" testId="invite-depot-select" />
            : depot && <p className="text-sm flex items-center gap-1.5 text-muted-foreground"><MapPin className="w-4 h-4 text-primary" />They join <span className="font-semibold text-foreground">{nameOf(depot)}</span></p>}
          {!link ? <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div> : (
            <>
              <p className="text-xs text-muted-foreground" data-testid="invite-where">Link for <span className="font-semibold text-foreground">{where}</span></p>
              <QrCard link={link} />
              <ShareRow link={link} />
              <EmailInvite depotId={depotId} />
              <ResetLink busy={busy} onReset={reset} />
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
